import { Base, Component, Prop, Provide } from '@/vue-property-decorator'
import { GameCardCommonProps, GameCardShape } from '../../../common.type'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { getProps } from './getProps'

export type VerticalCardMysize = 'default' | 'small' | 'larger' | 'stake-small'
type LocalCommomProps = Omit<GameCardCommonProps, 'bgImg'>
export interface VerticalProps extends LocalCommomProps {
  /** 是否[非维护状态下的鼠标悬浮,向上移动一下示意] */
  isHoverMove?: boolean
  /** 次级名称 */
  secondaryName?: string
  /** 尺寸大小(stake-smal小尺寸) */
  mySize?: VerticalCardMysize
  /** 当前卡片类型id */
  categoryId?: GameCategoryIds
  /** 当前卡片类型id */
  platformId?: number
}
/** 插槽 */
type Slots = {
  /** 状态名称标签 */
  labelGameStatus?: void
  /** 游戏名称插槽 */
  gameName?: void
  /** 虚拟彩金池 位置 */
  jockpot?: void
}
/** 游戏卡片
 * 垂直游戏卡片
 */
@Component<BasePropsConfig>({
  name: 'BasePropsConfig'
})
export default class BasePropsConfig extends Base<
  unknown,
  VerticalProps,
  unknown,
  Slots
> {
  /** 获得props */
  public static getProps = getProps

  @Prop({ default: GameCardShape.Vertical })
  protected inCardShape!: VerticalProps['inCardShape']
  @Prop()
  protected inCardRenderCategory!: VerticalProps['inCardRenderCategory']
  @Prop()
  protected status!: VerticalProps['status']
  @Prop()
  protected isFavorited!: VerticalProps['isFavorited']
  @Prop()
  protected gameName!: VerticalProps['gameName']
  @Prop()
  protected secondaryName!: VerticalProps['secondaryName']
  @Prop()
  protected imgUrl!: VerticalProps['imgUrl']
  @Prop()
  protected logoUrl!: VerticalProps['logoUrl']
  @Prop()
  protected categoryId!: VerticalProps['categoryId']
  @Prop()
  protected platformId!: VerticalProps['platformId']
  @Prop({ default: false })
  protected isMaintain!: VerticalProps['isMaintain']
  @Prop({ default: false })
  protected isCompleteImage!: VerticalProps['isCompleteImage']
  @Prop({ default: false })
  protected isCustomIcon!: VerticalProps['isCustomIcon']
  @Prop({ default: true })
  protected isShowFavorited!: VerticalProps['isShowFavorited']
  @Prop({ default: false })
  protected isHoverMove!: Required<VerticalProps>['isHoverMove']
  @Prop({ default: false })
  protected isAtSwiper!: VerticalProps['isAtSwiper']
  @Prop()
  protected atSwiperDomId!: VerticalProps['atSwiperDomId']
  @Prop()
  protected handleClickCard!: Required<VerticalProps>['handleClickCard']
  @Prop()
  protected handleClickFavorIcon!: Required<VerticalProps>['handleClickFavorIcon']
  // 将接收到的props依赖注入给子集
  @Provide('cardProps')
  protected get cardProps() {
    return this.$props as Required<VerticalProps>
  }

  // 渲染入口.
  render() {
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
